import { graphql, useStaticQuery } from 'gatsby';
import Button from '../../atoms/button/button';
import './notBussinessModal.scss';

interface NotBusinessModalInterface {
    closeModal: () => void;
    isMobile: boolean;
}

const NotBusinessModal = (props: NotBusinessModalInterface) => {
    const data = useStaticQuery(graphql`
        query GET_MODAL_NO_CONTINUAR {
            allContentfulTemplate(
                filter: {
                    titulo: { eq: "Modal no podemos continuar con el proceso" }
                }
            ) {
                nodes {
                    nombre
                    subtitulo
                    imagen {
                        file {
                            url
                        }
                    }
                    boton {
                        copy
                        redireccion
                    }
                }
            }
        }
    `);

    const contentData = data.allContentfulTemplate.nodes[0];
    const { imagen, nombre, boton, subtitulo } = contentData ?? {};

    const setModalClose = () => {
        props.closeModal();
    };

    const setValueClose = () => {
        setModalClose();
    };
    return (
        <div className={'m-not-business-modal'}>
            <div className="m-not-business-modal__content" onClick={() => {}}>
                <div className="m-not-business-modal__exit">
                    <i
                        className="icon icon-close m-not-business-modal__exit-icon"
                        onClick={setModalClose}
                    />
                </div>
                {contentData && (
                    <div className="m-not-business-modal__container">
                        <img
                            className="m-not-business-modal__container-icon"
                            src={imagen[0].file.url}
                            alt={imagen[0].title}
                            title={imagen[0].title}
                        />
                        <h3 className="m-not-business-modal__container-title">
                            {nombre}
                        </h3>
                        <p className="m-not-business-modal__container-subtitle">
                            {subtitulo}
                        </p>
                        <div className="m-not-business-modal__container__buttons">
                            <Button
                                type="button"
                                classname="m-not-business-modal__container__buttons__btn__primary"
                                text={boton[0].copy}
                                isDisabled={false}
                                onClickAction={setValueClose}
                            />
                            <Button
                                type="button"
                                classname="m-not-business-modal__container__buttons__btn__secondary"
                                text={boton[1].copy}
                                isDisabled={false}
                                onClickAction={() =>
                                    (window.location.href =
                                        boton[1].redireccion)
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
            <div
                className="m-not-business-modal__bkg"
                onClick={setModalClose}
            ></div>
        </div>
    );
};

export default NotBusinessModal;
